import { uploadLocationInfoAttachment } from '../apmLocationInfoAttachment';
import {
    addItem,
    deleteItem,
    emptyCollection,
    fetchCollection,
    fetchItem,
    updateItem,
} from '../collectionActions';

const paramsFunction = ({ params: { labelFields, ...params } }) => ({
    ...params,
    fields: labelFields,
});

export const fetchApmLocationInfoCollection = apmId =>
    fetchCollection({
        apiCollectionName: `apms/${apmId}/location-info`,
        collectionActionName: 'APM_LOCATION_INFO',
    });

export const fetchApmLocationInfo = ({ apmId, ...other }) =>
    fetchItem({
        apiCollectionName: `apms/${apmId}/location-info`,
        itemActionName: 'APM_LOCATION_INFO_ITEM',
    })(other);

export const updateApmLocationInfo = ({ apmId, ...other }) =>
    updateItem({
        apiCollectionName: `apms/${apmId}/location-info`,
        itemActionName: 'APM_LOCATION_INFO_ITEM',
        paramsFunction,
    })(other);

export const addApmLocationInfo =
    ({ apmId, attachments, ...other }) =>
    async dispatch => {
        const item = await dispatch(
            addItem({
                apiCollectionName: `apms/${apmId}/location-info`,
                itemActionName: 'APM_LOCATION_INFO_ITEM',
                paramsFunction,
            })(other)
        );

        await Promise.all(
            attachments.map(({ formData }) =>
                dispatch(uploadLocationInfoAttachment({ apmId, formData, id: item.id }))
            )
        );

        return item;
    };

export const deleteApmLocationInfo = ({ apmId, ...other }) =>
    deleteItem({
        apiCollectionName: `apms/${apmId}/location-info`,
        itemActionName: 'APM_LOCATION_INFO_ITEM',
    })(other);

export const emptyApmLocationInfo = emptyCollection({ collectionActionName: 'APM_LOCATION_INFO' });
